import React, { createContext, useState, useContext, useEffect } from 'react';

const AppContext = createContext();

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within AppProvider');
  }
  return context;
};

export const AppProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [settings, setSettings] = useState(null);

  const translations = {
    en: {
      enter: 'ENTER',
      settings: 'Settings',
      channels: 'Channels',
      playlists: 'Playlists',
      history: 'Watch History',
      timeLimit: 'Time Limit',
      search: 'Search',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      add: 'Add',
      backToChannels: 'Back to Channels',
      backToHome: 'Back to Home',
      selectChannel: 'Select a Channel',
      createPasscode: 'Create Your Passcode',
      enterPasscode: 'Enter Passcode',
      youtubeApiKey: 'YouTube API Key',
      searchChannels: 'Search YouTube Channels',
      approvedChannels: 'Approved Channels',
      addChannel: 'Add Channel',
      createPlaylist: 'Create Playlist',
      playlistName: 'Playlist Name',
      dailyLimit: 'Daily Time Limit (minutes)',
      timeUsedToday: 'Time Used Today',
      timeLimitReached: 'Daily time limit reached!',
      watchAgainTomorrow: 'Come back tomorrow to watch more videos',
      noChannels: 'No channels added yet',
      addChannelsFirst: 'Parents need to add channels first',
      logout: 'Logout'
    },
    ar: {
      enter: 'دخول',
      settings: 'الإعدادات',
      channels: 'القنوات',
      playlists: 'قوائم التشغيل',
      history: 'سجل المشاهدة',
      timeLimit: 'حد الوقت',
      search: 'بحث',
      save: 'حفظ',
      cancel: 'إلغاء',
      delete: 'حذف',
      add: 'إضافة',
      backToChannels: 'العودة إلى القنوات',
      backToHome: 'العودة إلى الصفحة الرئيسية',
      selectChannel: 'اختر قناة',
      createPasscode: 'أنشئ رمز المرور',
      enterPasscode: 'أدخل رمز المرور',
      youtubeApiKey: 'مفتاح YouTube API',
      searchChannels: 'ابحث عن قنوات يوتيوب',
      approvedChannels: 'القنوات المعتمدة',
      addChannel: 'إضافة قناة',
      createPlaylist: 'إنشاء قائمة تشغيل',
      playlistName: 'اسم قائمة التشغيل',
      dailyLimit: 'الحد اليومي للوقت (بالدقائق)',
      timeUsedToday: 'الوقت المستخدم اليوم',
      timeLimitReached: 'تم الوصول إلى الحد اليومي!',
      watchAgainTomorrow: 'عد غداً لمشاهدة المزيد من الفيديوهات',
      noChannels: 'لا توجد قنوات مضافة بعد',
      addChannelsFirst: 'يجب على الوالدين إضافة القنوات أولاً',
      logout: 'تسجيل الخروج'
    }
  };

  const t = (key) => translations[language][key] || key;

  return (
    <AppContext.Provider
      value={{
        language,
        setLanguage,
        isAuthenticated,
        setIsAuthenticated,
        settings,
        setSettings,
        t
      }}
    >
      <div dir={language === 'ar' ? 'rtl' : 'ltr'}>
        {children}
      </div>
    </AppContext.Provider>
  );
};
